__webpack_require__.p = "js/ring/";